import axiosInstance from './axios-instance';

export const sendOtpEmail = async (payload) => {
  const result = await axiosInstance.post(
    `/api/v1/backend/auth-gateway/two-factor/send-email-code`,
    payload
  );

  return result;
};

export const disable2FA = async (otp) => {
  const result = await axiosInstance.post(`/api/v1/backend/auth-gateway/two-factor/disable`, otp);

  return result;
};

export const verifySetup = async (payload) => {
  const result = await axiosInstance.post(
    `/api/v1/backend/auth-gateway/two-factor/verify-setup`,
    payload
  );

  return result;
};

export const setup2FA = async (payload) => {
  const result = await axiosInstance.post(`/api/v1/backend/auth-gateway/two-factor/setup`, payload);

  return result;
};

export const getQrCodeUrl = async (payload) => {
  const result = await axiosInstance.post(
    `/api/v1/backend/auth-gateway/two-factor/view-2fa-code`,
    payload
  );

  return result;
};
